export const OPENAI_CHAT_COMPLETIONS_RAW_MODEL_EVENT_SOURCE =
  'openai-chat-completions';
